import { render, staticRenderFns } from "./BuckBenefits.vue?vue&type=template&id=01debf06&"
import script from "./BuckBenefits.vue?vue&type=script&lang=ts&"
export * from "./BuckBenefits.vue?vue&type=script&lang=ts&"
import style0 from "./BuckBenefits.vue?vue&type=style&index=0&id=01debf06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports